import Pusher from 'pusher-js';
import { createContext, useState, useRef, useEffect, useCallback } from 'react';
import { jsx } from '@emotion/react/jsx-runtime';

const EventHandlerContext = /*#__PURE__*/createContext({});
/**
 * Provider that creates your Event handler instance and provides it to child hooks throughout your app.
 * @param props Config for EventHandler client
 */
const EventHandlerProvider = _ref => {
  let {
    debug = false,
    children,
    client: externalClient,
    clientKey = '',
    clientOptions
  } = _ref;
  const [active, setActive] = useState(!!externalClient);
  const clientRef = useRef(externalClient);
  useEffect(() => {
    if (!clientKey && !externalClient) {
      throw new Error('You must provide client or clientKey');
    }
  }, [clientKey, externalClient]);
  useEffect(() => {
    Pusher.logToConsole = debug;
  }, [debug]);
  const activateClient = useCallback(() => {
    const newClient = new Pusher(clientKey, clientOptions);
    clientRef.current = newClient;
    setActive(true);
    return newClient;
  }, [clientKey, clientOptions]);
  const subscribeChannel = useCallback(channelName => {
    var _clientRef$current;
    // Checks if client is already created. Otherwise, it is created
    const clientInstance = (_clientRef$current = clientRef.current) !== null && _clientRef$current !== void 0 ? _clientRef$current : activateClient();

    // Checks if channel is already subscribed
    let channel = clientInstance === null || clientInstance === void 0 ? void 0 : clientInstance.channel(channelName);
    if (!channel) {
      // Subscribed to the channel
      channel = clientInstance.subscribe(channelName);
    }
    return channel;
  }, [activateClient]);
  return jsx(EventHandlerContext.Provider, {
    value: {
      active,
      client: clientRef.current,
      activateClient,
      subscribeChannel
    },
    children: children
  });
};

export { EventHandlerContext, EventHandlerProvider };
//# sourceMappingURL=EventHandlerProvider.js.map
